export const VB_MODES = {
  OFF: 'off',
  BLUR: 'blur'
}

export const VB_BLUR_AMOUNT = 10
export const VB_CANVAS_SIZE = 256
export const VB_TARGET_FPS = 20
export const VB_INIT_TIMEOUT_MS = 10000
